import { render } from "./DbTablesList.vue?vue&type=template&id=62c53213"
import script from "./DbTablesList.vue?vue&type=script&lang=js"
export * from "./DbTablesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__